import styled from 'styled-components';

export interface IInputProps {
    isNotValid?: boolean;
}

export const DropdownInputWrapper = styled.div<IInputProps>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: max-content;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
  
  .dropdown-heading {
        background: #f4f4f4;
        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
    }

    .dropdown-content {
        label {
            padding: 5px;
            margin: 0;
            display: flex;
        }
        input {
            padding: 5px;
            margin: 0;
        }
        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.9rem;
            border-bottom: 1px solid #ddd;
            background: #eee;
        }
        .item-renderer > span {
            display: block;
            margin: 0;
            padding: 0;
            padding-left: 3px;
        }
    }
`;
